<template>
  <div>
    <common-table
      url="/api/platform/getWechatTempByPage"
      deleteUrl="/api/platform/deleteWechatTempById"
      :column="column"
      :operate="operate"
      ref="table"
      :searchForm="searchForm"
      :searchButtons="buttons"
    >

    </common-table>
    <submit-form
      :title="formTitle"
      :visible.sync="formVisible"
      :formData="formData"
      :items="items"
      :rules="rules"
      :action="action"
      addUrl="/api/platform/insertWechatTemp"
      updateUrl="/api/platform/updateWechatTemp"
      :onSubmitCallback="onSubmitCallback"
      :handleClose="handleClose"
    ></submit-form>
  </div>

</template>

<script>
  import utils from '../utils/utils'
    export default {
        name: "wechat-message-template",
      data(){
          return{
            column:[{
              prop:"type",
              label:"通知类型",
              formatter:this.typeFormatter
            },{
              prop:"class",
              label:"通知应用",
              formatter:this.classForMatter
            },{
              prop:"content",
              label:"模板说明",
              width:380
            },{
              prop:"tempId",
              label:"模板ID"
            },{
              prop:"isWork",
              label:"生效状态",
              formatter:this.isWorkFormatter
            }],
            operate:[{
              key:"edit",
              name:"编辑",
              handleClick:this.editRow
            }
            // ,{
            //   key:"delete",
            //   name:"删除"
            // },{
            //   key:"publish",
            //   condition:{
            //     prop:"isWork",
            //     label:[{
            //       value:"1",
            //       name:"取消发布"
            //     },{
            //       value:"0",
            //       name:"发布"
            //     }]
            //   },
            //   handleClick:this.publishRow
            // }
            ],
            searchForm:{

            },
            buttons:[],
            formTitle:"",
            formVisible:false,
            action:"",
            formData:{
              type:"1",
              content:"",
              tempId:"",
              isWork:"1"
            },
            items:[{
              key:"type",
              name:"type",
              label:"通知类型",
              type:"select",
              prop:"content",
              disabled:true,
              options:[{
                value:"1",
                label:"订单状态更新提醒"
              },{
                value:"2",
                label:"积分变动通知"
              },{
                value:"3",
                label:"预约成功"
              },{
                value:"4",
                label:"预约取消"
              },{
                value:"5",
                label:"提现审核"
              },{
                value:"6",
                label:"中奖通知"
              },{
                value:"7",
                label:"签到消息"
              }]
            },{
              key:"tempId",
              name:"tempId",
              label:"模板ID",
              type:"input",
              prop:"tempId"
            },{
              key:"content",
              name:"content",
              label:"通知说明",
              type:"textarea",
              prop:"content"
            }],
            rules:{
              type:[{required: true, message: '请选择通知类型', trigger: 'change'}],
              content:[{required: true, message: '请输入通知说明', trigger: 'blur'}],
              tempId:[{required: true, message: '请输入模板ID', trigger: 'blur'}],
            },
            typeList:[{
              value:"1",
              label:"订单状态更新提醒"
            },{
              value:"2",
              label:"积分变动通知"
            },{
              value:"3",
              label:"预约成功"
            },{
              value:"4",
              label:"预约取消"
            },{
              value:"5",
              label:"提现审核"
            },{
              value:"6",
              label:"中奖通知"
            },{
              value:"7",
              label:"签到消息"
            }]
          }
      },
      methods:{
        editRow(row){
          this.formTitle = "编辑";
          this.formVisible = true;
          this.action = "update";
          this.formData = {
            type:row.type,
            content:row.content,
            tempId:row.tempId,
            id:row.id,
            isWork:row.isWork
          }
        },
        onCreate(){
          this.formTitle = "新增";
          this.formVisible = true;
          this.action = "add";
        },
        onSubmitCallback(){
          this.$refs['table'].getData();
        },
        handleClose(){
          this.formData = {
            type:"1",
            content:"",
            tempId:"",
            isWork:"1"
          }
        },
        typeFormatter(row, column, cellValue, index){
          return this.typeList.filter(item => item.value === cellValue)[0].label;
        },
        classForMatter(row, column, cellValue, index){
          return "公众号"
        },
        isWorkFormatter(row, column, cellValue, index){
          return cellValue == "1" ? "已发布":"未发布"
        },
        publishRow(row){
          let formData = new FormData();
          if(row.isWork == "0"){
            formData.append("isWork","1")
          }else{
            formData.append("isWork","0")
          }
          formData.append("id",row.id)
          utils.axiosMethods({
            method:"POST",
            data:formData,
            url:"/api/platform/updateWechatTemp",
            callback:(res) => {
              this.$message.success("操作成功");
              this.$refs['table'].getData();
            }
          })
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/wechatMessageTemplate.vue